export type PartnerItem = {
    img: string;
    title: string;
    url: string;
    text: string;
};

export const partners: PartnerItem[] = [
    {
        img: require('../../assets/images/partners/partner1.png'),
        title: 'Единая карта петербуржца',
        url: 'https://ekp.spb.ru/',
        text: 'При предъявлении карты можно получить скидку 10% или 15%.',
    },
    {
        img: require('../../assets/images/partners/partner2.png'),
        title: 'Ленинградский областной реабилитационный центр',
        url: 'https://locmr.ru/',
        text: 'Скидки до 25%. *Подробности у администратора.',
    },
    {
        img: require('../../assets/images/partners/partner3.png'),
        title: 'Онкологика',
        url: 'https://oncologica.ru/',
        text: '20% скидка по договору.',
    },
    {
        img: require('../../assets/images/partners/partner4.png'),
        title: 'ВОИ, Санкт-Петербургское региональное отделение',
        url: 'https://voipiter.ru/',
        text: 'Специальные условия обслуживания для членов ВОИ.',
    },
];


